import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import Layout from '../components/Layout'
import { HTMLContent } from '../components/Content'
import GuidePostTemplate from './GuidePostTemplate';
import { defineCustomElements as deckDeckGoHighlightElement } from "@deckdeckgo/highlight-code/dist/loader";

const GuidePost = ({ data }) => {
  useEffect(() => {
    deckDeckGoHighlightElement();
  })

  const { post, allGuides } = data;

  function computeSections() {
    let guidesBySection = {};

    if (typeof allGuides.edges === 'undefined') {
      return [];
    }

    for (const i in allGuides.edges) {
      const edge = allGuides.edges[i];
      const sectionName = edge.node.frontmatter.section;

      if (sectionName) {
        if (typeof guidesBySection[sectionName] === 'undefined') {
          guidesBySection[sectionName] = {
            name: sectionName,
            guides: []
          };
        }

        guidesBySection[sectionName].guides.push({
          slug: edge.node.fields.slug,
          title: edge.node.frontmatter.title,
          priority: edge.node.frontmatter.priority,
        });
      }
    }

    const guides = Object.values(guidesBySection).map(section => {
      section.guides = section.guides.sort((a, b) => {
        const aPriority = a.priority || 0;
        const bPriority = b.priority || 0;

        if (aPriority > bPriority) {
          return -1;
        } else if (aPriority < bPriority) {
          return 1;
        }

        return 0;
      });

      return section;
    });

    var sectionPriorities = {
      'Getting Started': 1,
      'Data Matching': 2,
      'Results': 3,
      'Troubleshooting': 4,
      'Billing & Payment': 5,
      'Geocodio Unlimited': 6,
      'Account': 7,
      'Geocodio Maps': 8,
      'Enterprise': 9,
    };

    return guides.sort((a, b) => {
      const aPriority = sectionPriorities[a.name] || 0;
      const bPriority = sectionPriorities[b.name] || 0;

      if (aPriority > bPriority) {
        return 1;
      } else if (aPriority < bPriority) {
        return -1;
      }

      return 0
    });
  }

  return (
    <Layout title={`${post.frontmatter.title} | Guide`} description={post.frontmatter.description}>
      <GuidePostTemplate
        content={post.html}
        contentComponent={HTMLContent}
        guidesBySection={computeSections()}
        section={post.frontmatter.section}
        title={post.frontmatter.title}
      />
    </Layout>
  )
}

GuidePost.propTypes = {
  data: PropTypes.shape({
    post: PropTypes.object,
    allGuides: PropTypes.object,
  }),
}

export default GuidePost

export const pageQuery = graphql`
  query GuidePostByID($id: String!) {
    post: markdownRemark(id: { eq: $id }) {
      id
      html
      frontmatter {
        title
        description
        section
      }
    }

    allGuides: allMarkdownRemark(
      filter: { frontmatter: { templateKey: { eq: "guide-post" } }}
    ) {
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            section
            title
            priority
          }
        }
      }
    }
  }
`
